// Variante del marker de un incidente —cuál de los SVG de su categoría—. Es la
// ÚNICA regla: la usan el mapa vivo (deriveIconStatus en monitor-normalizer.js)
// y el mapa del reporte de incidentes. Si divergieran, el mismo incidente se
// vería distinto en las dos pantallas.
//
// `generated` es VITE_USE_GENERATED_ICONS: los SVG pre-pintados por tema traen
// alta/media/baja; el pack viejo solo up/down (y «alta»).
export function incidentIconStatus(activo, prioridad, generated) {
  if (!activo) return generated ? 'baja' : 'down'
  const p = String(prioridad || '').toUpperCase()
  if (p === 'ALTA' || p === 'HIGH') return 'alta'
  if (p === 'MEDIA' || p === 'MEDIUM') return generated ? 'media' : 'up'
  if (p === 'BAJA' || p === 'LOW') return generated ? 'baja' : 'up'
  return generated ? 'media' : 'up'
}
